<template>
    <div>
        <buttonlist  @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @current-change="handleCurrentChanges"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column prop="Rule_NO" :label="$t('getapi[3359]')">
                        <template scope="scope">
                            <input
                                    type="text"
                                    class="fsd clerinput"
                                    @keydown="keydown($event, scope.$index)"
                                    @keyup="keyup($event, scope.row)"
                                    v-model="scope.row.Rule_NO"
                                    readonly
                            />
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Rule_Name"
                                     :label="$t('getapi[6031]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Customer_Name"
                                     :label="$t('getapi[2584]')"></el-table-column>
                    <el-table-column prop="Rule_Status"
                                     :label="$t('getapi[552]')">
                        <template scope="scope">
                            <span>{{ scope.row.Rule_Status | lanchange}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Rule_priority" :label="$t('getapi[6032]')"
                                     align="right">
                        <template slot-scope="scope">
                            {{scope.row.Rule_priority | thousandth}}
                        </template>
                    </el-table-column>
                   <!--<el-table-column show-overflow-tooltip prop="Pur_Amount_Min" :label="$t('getapi[6033]')"
                                     align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Pur_Amount_Max" :label="$t('getapi[6034]')"
                                     align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Pur_Person"
                                     :label="$t('getapi[1167]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Pur_Mode_ID"
                                     :label="$t('getapi[1100]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ApprovalType"
                                     :label="$t('getapi[6035]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="PO_Change"
                                     :label="$t('getapi[6036]')"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_person"
                                     :label="$t('getapi[1616]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_time"
                                     :label="$t('getapi[3672]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_person"
                                     :label="$t('getapi[1616]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Modify_time"
                                     :label="$t('getapi[3672]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:840px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[3359]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.rule_no" type="text" size="mini"
                                          :readonly="addoredit == 2" :class="{'readO':addoredit == 2}"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[6031]') }}</td>
                            <td colspan="5">
                                <el-input v-model="dataDetail.Head.rule_name" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[552]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.rule_status" size="mini">
                                    <el-option v-for="item in ruleArray" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[143]') }}</td>
                            <td colspan="5">
                                <el-input v-model="dataDetail.Head.remark" type="text" size="mini"></el-input>
                            </td>
                        </tr>
                        <!--<tr>
                            <td>客户名称</td>
                            <td>
                                <el-input
                                        v-model="dataDetail.Head.Customer_Name"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectproject()"></i>
                                </el-input>
                            </td>
                            <td>客户代码</td>
                            <td  style="width:150px;">
                                <el-input v-model="dataDetail.Head.Customer_ID" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>-->
                        <tr>
                            <td>{{ $t('getapi[410]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.create_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[3672]') }}</td>
                            <td style="width:150px;">
                                <el-date-picker v-model="dataDetail.Head.create_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td  style="width:60px;">{{ $t('getapi[733]') }}</td>
                            <td  style="width:150px;">
                                <el-input v-model="dataDetail.Head.modify_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td  style="width:60px;">{{ $t('getapi[734]') }}</td>
                            <td  style="width:150px;">
                                <el-date-picker v-model="dataDetail.Head.modify_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="btnnowrap">
                    <el-button type="primary" size="mini" @click="selectemployee(2)">{{ $t('getapi[438]') }}</el-button>
                    <el-button type="primary" size="mini" @click="delbatch" :disabled="!btn.rowdel">{{
                        $t('getapi[1522]') }}
                    </el-button>
                </div>
                <el-table id="xdetilpane-0" :data="dataDetail.Lists" :height="tableHeight - 140" size="mini" border
                          style="width: 100%; margin-top:8px" @selection-change="handleSelectionChange">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="line_no" :label="$t('getapi[1297]')" width="50">
                        <template scope="scope">
                            <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.line_no"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="auditperson" :label="$t('getapi[6039]')" width="100">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.auditperson"
                                    type="text"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1, scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="department_name" :label="$t('getapi[1833]')"
                                     width="100"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="post_name" :label="$t('getapi[3180]')"
                                     width="100">
                        <template scope="scope">
                            <el-input size="mini" v-model="scope.row.post_name"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurApprovalRuleViewInfo" ref="ser" @getser="serclick"></serce>
        <!--采购订单-->
        <selector :isVisible="false" :selectType="2" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetSALCustomerDataList'"
                  @callback="getproject" ref="input"></selector>
        <!--<employee :isVisible="employeeVisible" @getemployee="getemployee" ref="employee"></employee>-->

        <selector :isVisible="employeeVisible" :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="employee"></selector>
        <selector :isVisible="employeeVisible" :isBatch=false :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployeesingle" ref="employeesingle"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'wxpriceapplication',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wxpriceapplication'), // 当前页数据量
                SelectIndexs: 3, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {},
                    Lists: []
                }, // 编辑页面数据详情
                oldDataDetail: '',
                code: '',
                ruleArray: [
                    {
                        Code: 1,
                        Name: this.$t('getapi[1170]')
                    },
                    {
                        Code: 0,
                        Name: this.$t('getapi[1171]')
                    }
                ],
                employeeVisible: false, //
                itemVisible: false,
                selectindex: 0, // 审批数组选择行
                addoredit: -1, // 新增还是修改
                ArrayPurType: [], // 采购方式
                ArrayApprovalType: [],
                employeeType: '',
                btn: {
                    rowdel: false
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('priceapplication', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.ArrayPurType = Array.methods.getPurType();
            that.ArrayApprovalType = Array.methods.getApproval();
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (row.Rule_Status == '无效') {
                    return 'gray';
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6563]"),this.$t("getapi[13]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority(type) {
                let that = this;
                if(!this.$limits.menuvisible("plv2", 524, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 523, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 524, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 524, 1) == 2) {
                        if(that.$limits.authority('plv3', 524, 1) == 0){
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 524, 1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                        if (that.$limits.authority('plv3', 524, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.rule_no)) {
                                if (that.dataDetail.Head.rule_status == 1) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
            },
            btnauthority() {
                let that = this;
                if (that.selectData.length > 0) {
                    that.btn.rowdel = true;
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                let result = this.dataSet.findIndex(item => item.Rule_NO === val.Rule_NO);
                let fsd = document.getElementsByClassName('fsd');
                fsd[result].focus();
                this.currentRow = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wxpriceapplication',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurApprovalRuleViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Approval/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.Rule_NO){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 477, 1)){
                        return
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.code = row.Rule_NO
                                that.getDetail(row.Rule_NO);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.code = row.Rule_NO
                        that.getDetail(row.Rule_NO);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(Rule_NO) {
                let that = this;
                that.addoredit = 2;
                let parm = {
                    Code: Rule_NO
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Approval/GetPurApprovalBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.po_change = that.dataDetail.Head.po_change == 1 ? true : false;
                        that.dataDetail.Head.isaddnew = 0
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority(2);
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = (
                    new Date().getFullYear() +
                    '-' +
                    (new Date().getMonth() + 1) +
                    '-' +
                    new Date().getDate() +
                    ' ' +
                    new Date().getHours() +
                    ':' +
                    new Date().getMinutes() +
                    ':' +
                    new Date().getSeconds()
                ).toString();
                that.isShowEdit = true;
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        rule_no: '',
                        rule_name: '',
                        rule_status: 1,
                        rule_priority: 0,
                        old_rule_priority: '',
                        pur_amount_min: 0,
                        pur_amount_max: 0,
                        pur_person: '',
                        pur_mode_id: '',
                        approvaltype: 2,
                        po_change: false,
                        remark: '',
                        create_person: that.user,
                        create_time: datetime,
                        modify_person: '',
                        modify_time: '',
                        isaddnew: 1,
                        Customer_ID: '',
                        Customer_Name: '',
                        Rule_Type: 3
                    },
                    Lists: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority(2);
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();*/
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 2){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit == 2){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[6542]')
                };
                that.$http.urlpost('/Pur/Approval/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.dataDetail.Head.po_change = that.dataDetail.Head.po_change == true ? 1 : 0;
                let parm = that.dataDetail;
                that.$http.urlpost('/Pur/Approval/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            selectproject() {
                let that = this;
                that.$refs.input.clearInput(true);
            },
            getproject(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Head.Customer_ID = val.customer_id;
                that.dataDetail.Head.Customer_Name = val.customer_name;
            },
            selectemployee(type, row) {
                let that = this;
                that.employeeType = type;
                that.employeeVisible = true;
               if (type == 1) {
                    that.selectindex = row.$index;
                    that.addoredit = 'edit';
                    that.$refs.employeesingle.clearInput(this.employeeVisible, false, 2);
                } else if (type == 2) {
                    that.addoredit = 'add';
                    that.$refs.employee.clearInput(this.employeeVisible, true, 2);
                }
            },
            getemployeesingle(data){
                let that = this
                that.dataDetail.Lists[that.selectindex].exclusively_id = ''
                that.dataDetail.Lists[that.selectindex].relation_rule_no = ''
                that.dataDetail.Lists[that.selectindex].auditperson = data.name
                that.dataDetail.Lists[that.selectindex].userid = data.code
                that.dataDetail.Lists[that.selectindex].loginname = data.loginname
                that.dataDetail.Lists[that.selectindex].department_name = data.department
                that.dataDetail.Lists[that.selectindex].post_name = data.post
            },
            getemployee(data) {
                let that = this;
                console.log(data);
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate()
                if(that.dataDetail.Lists.length > 0){
                    data = data.filter(item => {
                        return that.dataDetail.Lists.every(item2 => {
                            return item2.userid != item.code
                        })
                    })
                }
                for (let i = 0; i < data.length; i++) {
                    let dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].line_no >= dataDetailLineNo) {
                            dataDetailLineNo = parseInt(that.dataDetail.Lists[i].line_no) + 1
                        }
                    }
                    that.dataDetail.Lists = [
                        ...that.dataDetail.Lists,
                        {
                            exclusively_id: '',
                            relation_rule_no: '',
                            line_no: dataDetailLineNo++,
                            auditperson: data[i].name,
                            userid: data[i].code,
                            loginname: data[i].loginname,
                            department_name: data[i].department,
                            post_name: data[i].post
                        }
                    ];
                }
            },
            // 新增物料
            showItem(row) {
                let that = this;
                that.itemVisible = true;
                that.$refs.input.clearInput(that.itemVisible, row.relation_regist_order_no);
            },
            // 获取物料信息
            getrecorder(data) {
                let that = this;
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].line_no);
                }
                that.btnauthority();
            },
            delbatch() {
                let that = this;
                let arr = that.dataDetail.Lists.filter(item => {
                    return that.selectData.every(item2 => {
                        return item.line_no != item2;
                    });
                });
                that.dataDetail.Lists = arr;
            },
            // 删除单据
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            rule_no: that.dataDetail.Head.rule_no,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$http.urlpost('/Pur/Approval/DelPurApproval', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 524,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .gray {
        background: #cac6c6;
    }
</style>
